module.exports = __webpack_public_path__ + "img/Dantam Makeover 11.eedc05f5.jpg";